import * as z from "zod";

const RiskEnumDto = {
    high: "high",
    favorable: "favorable",
    moderate: "moderate",
    low: "low",
} as const;
export type RiskEnumDto = (typeof RiskEnumDto)[keyof typeof RiskEnumDto];
const RiskEnumDtoSchema = z.enum(RiskEnumDto);

const PestCodeEnumDto = {
    araña_roja: "araña_roja",
    erwinia_carotovora: "erwinia_carotovora",
    alternaria: "alternaria",
    fusarium: "fusarium",
    phytophthora: "phytophthora",
    cotonet: "cotonet",
    chinche_verde: "chinche_verde",
    polilla_del_tomate: "polilla_del_tomate",
    pulgon: "pulgon",
    mosca_blanca: "mosca_blanca",
    thrips_parvispinus: "thrips_parvispinus",
    manchas_de_humedad: "manchas_de_humedad",
    pudricion: "pudricion",
    oidio: "oidio",
    mildiu: "mildiu",
    botritis: "botritis",
    abiotic_stress: "abiotic_stress",
} as const;
export type PestCodeEnumDto =
    (typeof PestCodeEnumDto)[keyof typeof PestCodeEnumDto];
const PestCodeEnumDtoSchema = z.enum(PestCodeEnumDto);

export const PestDtoSchema = z
    .object({
        id: z.number(),
        agent_id: z.number(),
        code: PestCodeEnumDtoSchema,
        name: z.string().trim(),
        infection_risk_level: RiskEnumDtoSchema.nullable(),
        infection_risk_percentage: z.number().nullable(),
        measured_at: z.string().trim(),
    })
    .readonly();
export type PestDto = z.output<typeof PestDtoSchema>;

export const PestAvgDtoSchema = z
    .object({
        avg_value: z.number(),
        hour_of_day: z.string().trim(),
        symbol: z.string().trim(),
        name: z.string().trim(),
        type: z.string().trim(),
    })
    .readonly();
export type PestAvgDto = z.output<typeof PestAvgDtoSchema>;

export const PestsDtoSchema = z
    .object({
        stations_risks: z.array(PestDtoSchema).readonly(),
        stations_risks_variables_avg: z.array(PestAvgDtoSchema).readonly(),
    })
    .readonly();
export type PestsDto = z.output<typeof PestsDtoSchema>;
